import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onBeforeUnmount } from "vue";
import * as d3 from "d3";
import { debug as Debug } from "debug";
import { CategoryCountData } from "./horizontal-bar-chart.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'donut-chart',
  props: {
    data: {},
    width: { default: 250 },
    height: { default: 250 }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const debug = Debug("cs.DonutChart");

const props = __props;

const emit = __emit;

const donutChartRef = ref<HTMLElement | null>(null);

function redraw(): void {
  // set the dimensions and margins of the graph
  const { width } = props;
  const { height } = props;
  const margin = 0;

  // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
  const radius = Math.min(width, height) / 2 - margin;

  // Remove any existing content
  if (!donutChartRef.value) {
    return;
  }

  donutChartRef.value.innerHTML = "";

  // append the svg object to the div called 'my_dataviz'
  const svg = d3
    .select(donutChartRef.value)
    .append("svg")
    .attr("width", width)
    .attr("height", height)
    .append("g")
    .attr("transform", `translate(${width / 2},${height / 2})`);

  // Compute the position of each group on the pie:
  const pie = d3
    .pie()
    .sort(null) // Do not sort group by size
    .value((data) => {
      return data.value;
    });
  const data_ready = pie(props.data);

  // The arc generator
  const arc = d3
    .arc()
    .innerRadius(radius * 0.5 * 0) // This is the size of the donut hole
    .outerRadius(radius * 0.8);

  // Another arc that won't be drawn. Just for labels positioning
  // const outerArc = d3
  //   .arc()
  //   .innerRadius(radius * 0.9)
  //   .outerRadius(radius * 0.9);

  // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
  svg
    .selectAll("allSlices")
    .data(data_ready)
    .enter()
    .append("path")
    .attr("d", arc)
    .attr("fill", (dat) => {
      return dat.data.colour;
    })
    .attr("stroke", "white")
    .style("stroke-width", "2px")
    .style("opacity", 1)

    .on("mouseover", (event: MouseEvent, d) => {
      emit("select", d.data);
      d3.select(event.currentTarget).transition().duration(50).style("opacity", 0.7);
    })
    .on("mouseout", (event: MouseEvent) => {
      d3.select(event.currentTarget).transition().duration(50).style("opacity", 1);
      emit("select", null);
    });
}

onMounted(() => {
  debug("mounted");
  window.addEventListener("resize", redraw);
  redraw();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", redraw);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "donutChartRef",
    ref: donutChartRef,
    class: "donut-chart"
  }, null, 512))
}
}

})